var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{attrs:{"name":_vm.name},on:{"change":_vm.change}},[_c('option',{attrs:{"value":""}},[_vm._v("\n    Select a State\n  ")]),_vm._v(" "),_vm._l((_vm.usStates),function(state,index){return _c('option',{key:index,domProps:{"selected":_vm.value === state.name,"value":state.name}},[_vm._v("\n    "+_vm._s(state.name)+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }